<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="楼栋名称"
                    prop="floorName">
                    <Input v-model="info.floorName"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="建筑面积"
                    prop="buildArea">
                    <input-number v-model="info.buildArea"
                        placeholder
                        :readonly="readonly">
                        <span slot="append">m²</span>
                    </input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="楼栋编号"
                    prop="floorNum">
                    <input-number :readonly="readonly"
                        v-model="info.floorNum"
                        placeholder
                        :min="1"
                        :max="999"
                        :allowDecimal="false"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="楼层总数"
                    prop="levelNum">
                    <input-number v-model="info.levelNum"
                        placeholder
                        :allowDecimal="false"
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="单元数"
                    prop="unitNum">
                    <input-number v-model="info.unitNum"
                        placeholder
                        :allowDecimal="false"
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="每单元户数"
                    prop="unitHouseNum">
                    <input-number v-model="info.unitHouseNum"
                        placeholder
                        :allowDecimal="false"
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="说明"
                    prop="remark">
                    <Input :readonly="readonly"
                        v-model="info.remark"
                        placeholder
                        type="textarea"
                        :rows="3"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { floorAdd, floorUpdate, floorView } from '@/api/proj-manager'
import Dict from '@/utils/dict'
export default {
    name: 'FormFloorForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                projId: '',
                floorName: '', //楼栋名称
                buildArea: '', //建筑面积
                floorNum: '', //楼栋编号
                levelNum: '', //楼层总数
                unitNum: '', //单元数
                unitHouseNum: '', //每单元户数
                remark: '', //说明
                ver: '' //版本号
            },
            attachments: '',
            dict: {
                saleStatus: Dict.NULL,
                livingRoom: Dict.NULL
            },
            loading: false
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly() {
            return this.loading || !this.canSave
        },

        ruleValidate() {
            return {
                floorName: [{ required: true, message: '楼栋名称必填' }],
                buildArea: [{ required: true, message: '建筑面积必填' }],
                floorNum: [{ required: true, message: '楼栋编号必填' }]
            }
        },
        saleStatusList() {
            return this.dict.saleStatus.val()
        },
        livingRoomList() {
            return this.dict.livingRoom.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return floorView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]
            
        this.info.projId = this.$route.params.id
        this.loading = true

        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                    Dict.get(['sale_status', 'living_room']),
                    this.fetch()
                ])
                .then(args => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return floorUpdate(formData)
                    } else {
                        return floorAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => (options.closeModal = false))
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>